import React, { useRef } from "react";
import { IconButton, Tooltip } from "@mui/material";
import postRibbon from "../../../../../Assets/statusRibbon/post.png";
import returnRibbon from "../../../../../Assets/statusRibbon/return.png";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { useState } from "react";
import { useEffect } from "react";
import Draft from "../../../../../Assets/statusRibbon/draft.png";
import { deliveryNoteSingleViewAPICall } from "./deliveryNoteAPI";
import { convertDateFormat, today } from "../../../../../Js/Date";
// Direct print without react-to-print
import { getTemplateAPI } from "../SalesQuotation/salesQuatationAPI";
import { set_Back_button_action } from "../../../../Single Components/listSlice/filterCategorySlice";
import ExcelJS from "exceljs";

export const DeliverNoteSingleView = () => {
  const printRef = useRef(null);

  // data of selected list
  const singleRowId = localStorage.getItem("singleViewById");
  const singleList = useSelector((state) => state?.deliveryNoteSlice?.rowData);

  // company details and info
  const companyProfileData =useSelector(
    (state) => state?.companyProfileSlice?.userValue)

    const dispatch = useDispatch();
    const template =useSelector((state)=>state?.salesQuatationSlice?.setTemplate)

  const formValuesInitialState = {
    status: "",
    companyLogo: "",
    companyName: "",
    companyAddress: "",
    companyContact: "",

    customerName: "",
    customerAddress: "",
    customerContact: "",

    deliveryName: "",
    deliveryAddress: "",
    deliveryContact: "",

    salesOrder:"",
    so:"SO No",
    name: "",
    dateN1:" Date",
    dateN2:"Expiry Date",
    firstDate: "",
    secondDate: "",

    termsAndCondition:"",

    lpo:"",
    sequence:"DN No",
    ref:"",
    subtotal: "",
    inclusiveTax: "",
    exclusiveTax: "",
    total: "",
    totalAmount:"",
    payTerm:"",
    label:"DELIVERY NOTE"
  };
  const [formValues, setFormValues] = useState(formValuesInitialState);
  const [data, setData] = useState([]);
  const [tax, setTax] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  // api to fetch companyprofile data

  const downloadList = () => {
  const workbook = new ExcelJS.Workbook();
  const sheet = workbook.addWorksheet("Delivery Note");
  
  // Set default styles
  sheet.properties.defaultRowHeight = 20;
  
  // Header Section
  const headerRow = sheet.addRow(["Delivery Note"]);
  headerRow.font = { size: 16, bold: true };
  headerRow.height = 25;
  sheet.mergeCells("A1:E1");
  headerRow.getCell(1).alignment = { vertical: "middle", horizontal: "center" };
  
  // Company Information
  sheet.addRow([`Company: ${formValues.companyName}`]);
  sheet.addRow([`Address: ${formValues.companyAddress}`]);
  sheet.addRow([`Contact: ${formValues.companyContact}`]);
  // Customer Information
  const customerHeaderRow = sheet.addRow(["Customer Address:"]);
  customerHeaderRow.font = { bold: true };
  sheet.addRow([`Name: ${formValues.customerName}`]);
  sheet.addRow([`Address: ${formValues.customerAddress}`]);
  sheet.addRow([`Contact: ${formValues.customerContact}`]);
  sheet.addRow([`Quotation Number: ${formValues.name}`]);
  sheet.addRow([`Quotation Date: ${formValues.firstDate}`]);
  sheet.addRow([`Expiry Date: ${formValues.secondDate}`]);
  // Table Header
  const tableHeaderRow = sheet.addRow([
    "No", "Product", "UOM", 
    "Demand Qty", formValues?.status === "RETURNED" ? "Return Qty" : "Delivered Qty"
  ]);
  
  // Style for table header
  const headerFill = {
    type: "pattern",
    pattern: "solid",
    fgColor: { argb: "FFEAEEF9" },
  };
  
  const headerFont = {
    size: 12,
    bold: true,
    color: { argb: "FF000000" },
  };
  
  tableHeaderRow.eachCell((cell, colNumber) => {
    cell.fill = headerFill;
    cell.font = headerFont;
    cell.alignment = { vertical: "middle", horizontal: "center" };
    // cell.border = {
    //   top: { style: "thin" },
    //   left: { style: "thin" },
    //   bottom: { style: "thin" },
    //   right: { style: "thin" }
    // };
  });
   const goodsData = data?.filter(obj => obj?.prodType === "Goods");
  // Table Data
   goodsData?.forEach((item, index) => {
    const row = sheet.addRow([
      index + 1,
      item.product || '', 
      item?.uomName || '', 
      item.orderQuantity || 0, 
      formValues?.status === "RETURNED" ? item?.returnQuantity : item?.deliveredQuantity
    ]);
    
    // Alternate row coloring
    const rowFill = {
      type: "pattern",
      pattern: "solid",
      fgColor: { argb: index % 2 === 0 ? "FFF1F2F5" : "FFFFFFFF" },
    };
    
    row.eachCell((cell) => {
      cell.fill = rowFill;
      // cell.border = {
      //   top: { style: "thin" },
      //   left: { style: "thin" },
      //   bottom: { style: "thin" },
      //   right: { style: "thin" }
      // };
      cell.alignment = { horizontal: "center" };
    });
  });
  
  // Table Footer (Totals)
  
  // Auto-size columns
  sheet.columns.forEach(column => {
    let maxLength = 0;
    column.eachCell({ includeEmpty: true }, cell => {
      const columnLength = cell.value ? cell.value.toString().length : 0;
      if (columnLength > maxLength) {
        maxLength = columnLength;
      }
    });
    column.width = Math.min(Math.max(maxLength + 2, 10), 30);
  });
  
  // Generate and download the Excel file
  workbook.xlsx.writeBuffer().then(function(data) {
    const blob = new Blob([data], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });
    const url = window.URL.createObjectURL(blob);
    const anchor = document.createElement("a");
    anchor.href = url;
    anchor.download = `Delivery_note_${formValues.name || 'DeliveryNote'}.xlsx`;
    anchor.click();
    window.URL.revokeObjectURL(url);
  });
};

  // Direct print function - bypasses react-to-print
  const handlePrint = () => {
    const printContent = printRef.current;
    if (!printContent) {
      alert('Print content not ready');
      return;
    }
    
    const printWindow = window.open('', '_blank');
    printWindow.document.write(`
      <html>
        <head>
          <title>Delivery Note - ${formValues?.name || 'DeliveryNote'}</title>
          <style>
            @page { size: A4; margin: 10mm; }
            body { font-family: Arial, sans-serif; margin: 0; padding: 20px; }
            table { width: 100%; border-collapse: collapse; }
            th, td { padding: 8px; border: 1px solid #ddd; }
            th { background-color: #333; color: white; }
            @media print {
              body { -webkit-print-color-adjust: exact; print-color-adjust: exact; }
            }
          </style>
        </head>
        <body>${printContent.innerHTML}</body>
      </html>
    `);
    printWindow.document.close();
    printWindow.focus();
    setTimeout(() => {
      printWindow.print();
      printWindow.close();
    }, 250);
  };

  useEffect(() => {
    setIsLoading(true);
    getTemplateAPI();
    if (singleRowId) {
      deliveryNoteSingleViewAPICall({ _id: singleRowId });
    } else {
      setIsLoading(false);
    }
  }, []);
  useEffect(() => {
    if (!singleList) {
      return;
    }
    
    setFormValues({
      ...formValues,
      status: singleList?.status,
      companyLogo: companyProfileData?.logo || "",
      companyName: companyProfileData?.companyName || "",
      companyAddress: companyProfileData?.companyAddress || "",
      companyContact: companyProfileData?.contactNumber || "",
      companyTRN: companyProfileData?.companyTRN || "",

      customerName: singleList?.customerAddress?.customername|| "",
      customerAddress: singleList?.customerAddress?.streetName || "",
      customerContact: singleList?.customerAddress?.mobileNo || "",
      termsAndCondition:singleList?.termsAndConditions || "",
      salesOrder:singleList?.salesOrderName||"",
      trn: singleList?.vendorAddress?.TRN || "",

      ref: singleList?.reference ||"",
      lpo: singleList?.LpoNo ||"",
      name: singleList?.name || `DN/${singleList?.deliveryNo}` || "",
      firstDate: singleList?.date || "",
      //secondDate: singleList?.dueDate || "",
      subtotal: singleList?.subTotal || "",
      inclusiveTax: singleList?.totalTaxInclusive || "",
      exclusiveTax: singleList?.totalTaxExclusive || "",
      totalAmount: singleList?.totalAmount || "",
      total: singleList?.total || "",
      payTerm: singleList?.PAYMENTTERM || "",
      qrcodetype: singleList?.qrcodetype || "",
      customerId: singleList?.customerId || "",
      db: singleList?.db || "",
      _id: singleList?._id || "",
    });
    setData(singleList?.salesInfo);
    setTax(singleList?.taxDetails);
    setIsLoading(false);
  }, [singleList, companyProfileData]);

  let navigateTo = useNavigate();
  const [domain, setDomain] = useState("");
  useEffect(() => {
    if (formValues) {
      let element = formValues;
      // const domainAddress = `${window.location.protocol}//${window.location.host}/posReaderPreview?path=admin/viewqrcodedata&db=${element?.db}&vendororcusid=${element?.supplierId}&type=${element?.qrcodetype}&orderId=${element?._id}`;
      const domainAddress = `${window.location.protocol}//${window.location.host}/posReaderPreview?path=admin/viewqrcodedata&db=${encodeURIComponent(element?.db)}&vendororcusid=${encodeURIComponent(element?.customerId)}&type=${encodeURIComponent(element?.qrcodetype)}&orderId=${encodeURIComponent(element?._id)}`;


      setDomain(domainAddress);
    }
  }, [formValues]);

  if (isLoading) {
    return (
      <div className="main-container" style={{ backgroundColor: "unset", padding: "0" }}>
        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '80vh' }}>
          <div style={{ textAlign: 'center' }}>
            <div className="spinner-border" role="status">
              <span className="sr-only">Loading...</span>
            </div>
            <p style={{ marginTop: '10px' }}>Loading delivery note...</p>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="main-container"style={{ backgroundColor: "unset", padding: "0" }}>
      <div className="first-div-container"style={{ backgroundColor: "white", justifyContent: "space-between" }}>
        {/* <div className="post-ribbon">
          {formValues?.status === "DRAFT" && <img src={Draft} alt="" />}
          {formValues?.status === "POSTED" && <img src={postRibbon} alt="" />}
          {formValues?.status === "RETURNED" && <img src={returnRibbon} alt="" />}
        </div> */}
        <div style={{display:"flex",gap:"8px"}}>
        
        <Tooltip title="Edit">
          <IconButton>
            <i
              class="bi bi-pencil-square edit-icon1"
              onClick={() =>
                navigateTo("/userdashboard/sales/orders/deliveryNote/create")
              }
            ></i>
          </IconButton>
        </Tooltip>
        
          <h3>
            <span
              
              style={{ fontSize: "medium", color: "black", cursor: "pointer" }}
              onClick={() =>
               { navigateTo("/userdashboard/sales/orders/deliveryNote")
               dispatch(set_Back_button_action({ backButtonClickAction: true }));}
              }
            >Delivery Note &gt;</span>
           <span style={{fontSize:"medium",paddingLeft:"8px"}}>{formValues?.name}</span>
          </h3>
        
        </div>
        {/* <ReactToPrint
          trigger={() => (
            <IconButton className="printer-div">
              <i style={{ color: "black" }} class="bi bi-printer"></i>
            </IconButton>
          )}
          content={() => paymentsPrint}
        /> */}

        <div>
        <Tooltip title="Share">
          <IconButton>
            <i class="bi bi-share" style={{ backgroundColor: "#9797e9", color: "white", fontSize: "medium", padding: "8px", borderRadius: "2px" }}></i>
          </IconButton>
        </Tooltip>

        <Tooltip title="Print">
          <IconButton onClick={handlePrint} className="printer-div" style={{ padding: "1px" }}>
            <i
              style={{
                color: "white",
                backgroundColor: "#d787e7",
                fontSize: "medium",
                padding: "8px",
                borderRadius: "2px",
              }}
              className="bi bi-printer"
            ></i>
          </IconButton>
        </Tooltip>
        <Tooltip  title="Download">
          <IconButton onClick={downloadList}>
            <i class="bi bi-arrow-down-circle" style={{ backgroundColor: "rgb(255 118 133 / 69%)", color: "white", fontSize: "medium", padding: "8px", borderRadius: "2px" }}></i>
          </IconButton>
        </Tooltip>
        </div>
      </div>
      {/* <hr className="line" /> */}
      <div style={{ backgroundColor: "white", height: "84vh", marginTop: "4px", position: "relative" }}>

      <div className="second-main-container">
      <div className="post-ribbon"style={{ right: "0px", top: "0px" }}>
          {formValues?.status === "DRAFT" && <img src={Draft} alt="" />}
          {formValues?.status === "POSTED" && <img src={postRibbon} alt="" />}
          {formValues?.status === "RETURNED" && <img src={returnRibbon} alt="" />}
        </div>
        <div className="left-side-div">
          <img src={formValues?.companyLogo} alt={formValues?.companyName} />
          <p>{formValues?.companyAddress}</p>
          <p>{formValues?.companyContact}</p>

          <h1 className="vendor-head">Vendor Address</h1>
          <p>{formValues?.customerName}</p>
          <p>{formValues?.customerContact}</p>      
          {/* <p>--</p>
          <p>--</p> */}

          <h1 className="vendor-head">Delivery To</h1>
          {/* <p>--</p>
          <p>--</p>
          <p>--</p> */}
        </div>
        <div className="right-side-div">
          <h1>Delivery Note</h1>
          <p>{formValues?.name}</p>
          <div className="date-div" style={{ width: "171px" }}>
            <p>
              <span class="date-container-single">Date:</span>
              {formValues?.firstDate}
            </p>
            {/* <p>--</p> */}
          </div>
        </div>
      </div>

      <div className="Table-container">
        <div className="Table-data">
          <table>
            <thead>
              <tr style={{ backgroundColor: "#eaeef9" }}>
                <th>No</th>
                <th>Product</th>
                <th>UOM</th>
                <th>Demand Qty</th>
                {formValues.status === "RETURNED"? <th>Return Quantity </th>  :<th>Done Qty</th>}

              </tr>
            </thead>
            <tbody>
              {data?.filter(obj=>obj?.prodType==="Goods")?.map((item, index) => (
                <tr
                  key={index}
                  style={{
                    backgroundColor: index % 2 === 0 ? "#f1f2f5" : "white",
                  }}
                >
                  <td>{index + 1}</td>
                  <td>{item.product}</td>
                  <td>{item.uomName}</td>
                  <td>{item.orderQuantity}</td>
                  <td>{formValues?.status === "RETURNED" ?item?.returnQuantity :item?.deliveredQuantity}</td>
                </tr>
              ))}
            </tbody>
            
          </table>
        </div>
      </div>
</div>
      {/* Print Content - Hidden but accessible for printing */}
      <div style={{ position: "absolute", left: "-9999px", top: 0 }}>
        <div ref={printRef} style={{ padding: "20px", fontFamily: "Arial, sans-serif", backgroundColor: "white" }}>
          {/* Header */}
          <div style={{ display: "flex", justifyContent: "space-between", marginBottom: "20px", borderBottom: "2px solid #333", paddingBottom: "10px" }}>
            <div>
              {formValues?.companyLogo && <img src={formValues?.companyLogo} alt="Logo" style={{ maxHeight: "60px" }} />}
              <h2 style={{ margin: "5px 0" }}>{formValues?.companyName}</h2>
              <p style={{ margin: "2px 0", fontSize: "12px" }}>{formValues?.companyAddress}</p>
              <p style={{ margin: "2px 0", fontSize: "12px" }}>{formValues?.companyContact}</p>
              {formValues?.companyTRN && <p style={{ margin: "2px 0", fontSize: "12px" }}>TRN: {formValues?.companyTRN}</p>}
            </div>
            <div style={{ textAlign: "right" }}>
              <h1 style={{ margin: "0", color: "#333" }}>DELIVERY NOTE</h1>
              <p style={{ margin: "5px 0", fontSize: "14px" }}><strong>DN No:</strong> {formValues?.name}</p>
              <p style={{ margin: "5px 0", fontSize: "14px" }}><strong>Date:</strong> {formValues?.firstDate}</p>
              {formValues?.salesOrder && <p style={{ margin: "5px 0", fontSize: "14px" }}><strong>SO Ref:</strong> {formValues?.salesOrder}</p>}
            </div>
          </div>

          {/* Customer Info */}
          <div style={{ marginBottom: "20px", padding: "10px", backgroundColor: "#f5f5f5" }}>
            <h3 style={{ margin: "0 0 10px 0" }}>Customer Details</h3>
            <p style={{ margin: "2px 0" }}><strong>Name:</strong> {formValues?.customerName}</p>
            <p style={{ margin: "2px 0" }}><strong>Contact:</strong> {formValues?.customerContact}</p>
            <p style={{ margin: "2px 0" }}><strong>Address:</strong> {formValues?.customerAddress}</p>
          </div>

          {/* Products Table */}
          <table style={{ width: "100%", borderCollapse: "collapse", marginBottom: "20px" }}>
            <thead>
              <tr style={{ backgroundColor: "#333", color: "white" }}>
                <th style={{ padding: "8px", border: "1px solid #333", textAlign: "center" }}>No</th>
                <th style={{ padding: "8px", border: "1px solid #333", textAlign: "left" }}>Product</th>
                <th style={{ padding: "8px", border: "1px solid #333", textAlign: "center" }}>UOM</th>
                <th style={{ padding: "8px", border: "1px solid #333", textAlign: "center" }}>Demand Qty</th>
                <th style={{ padding: "8px", border: "1px solid #333", textAlign: "center" }}>{formValues?.status === "RETURNED" ? "Return Qty" : "Delivered Qty"}</th>
              </tr>
            </thead>
            <tbody>
              {data?.filter(obj => obj?.prodType === "Goods")?.map((item, index) => (
                <tr key={index} style={{ backgroundColor: index % 2 === 0 ? "#f9f9f9" : "white" }}>
                  <td style={{ padding: "8px", border: "1px solid #ddd", textAlign: "center" }}>{index + 1}</td>
                  <td style={{ padding: "8px", border: "1px solid #ddd" }}>{item?.product}</td>
                  <td style={{ padding: "8px", border: "1px solid #ddd", textAlign: "center" }}>{item?.uomName}</td>
                  <td style={{ padding: "8px", border: "1px solid #ddd", textAlign: "center" }}>{item?.orderQuantity}</td>
                  <td style={{ padding: "8px", border: "1px solid #ddd", textAlign: "center" }}>{formValues?.status === "RETURNED" ? item?.returnQuantity : item?.deliveredQuantity}</td>
                </tr>
              ))}
            </tbody>
          </table>

          {/* Terms */}
          {formValues?.termsAndCondition && (
            <div style={{ marginTop: "20px", paddingTop: "10px", borderTop: "1px solid #ddd" }}>
              <h4>Terms & Conditions</h4>
              <p style={{ fontSize: "12px" }}>{formValues?.termsAndCondition}</p>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};
